export default "__VITE_ASSET__ELdh6_1r__"